// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: 'Montserrat', sans-serif
}

.nav-link {
  color: white !important;
}


a {
  text-decoration: none !important;
}

/* HOVER */

.custom-hover {
  position: relative;
  color: white;
  overflow: hidden;
  /* border: solid 1px; */
  outline: none !important;
  z-index: 99;
  background: white;
}

.custom-hover:hover {
  color:  black;
}

.custom-hover::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  z-index: -1;
  border-radius: 10%;
  transform-origin: left;
  transition: transform 500ms ease-in-out;
  transform: scaleX(1);
}

.custom-hover:hover::before,
.custom-hover:focus::before
 {
   transform-origin: right;
   transition: transform 0.5s ease-in-out;
   transform: scaleX(0);
}

/* REVERSE COLOR HOVER */

.reverse-custom-hover {
  position: relative;
  color: black;
  overflow: hidden;
  border: solid 1px;
  outline: none !important;
  z-index: 99;
  background: black;
}

.reverse-custom-hover:hover {
  color: white;
}

.reverse-custom-hover::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: -1;
  border-radius: 10%;
  transform-origin: left;
  transition: transform 500ms ease-in-out;
  transform: scaleX(1);
}

.reverse-custom-hover:hover::before,
.reverse-custom-hover:focus::before
 {
   transform-origin: right;
   transition: transform 0.5s ease-in-out;
   transform: scaleX(0);
}




/* ART TYPE OPENING ANIMATION*/

.custom-animation {
  width: 100px;
  height: 150px;
  animation: animate 5s ease-in-out;
  
}

@keyframes animate {
  0% {
    height: 150px;
    width: 100px;
    top: 50%;
  }

  20% {
    height: 300px;
    width: 300px;
    top: 50%;
  }

  30% {
    height: 300px;
    width: 300px;
    top: 50%;

  }

  50% {
    width: 1000px;
    height: 1000px;
    top: 50%;
  }

  60% {
    width: 1000px;
    height: 1000px;
    top: 50%;
  }
  

  85% {
    width: 1000px;
    height: 1000px;
    top: -200vh;
  }
  100% {
    width: 1000px;
    height: 1000px;
    top: -200vh;
    display: none;
  }
}



/* FLOATING ANIMATION */
.floating {
  animation: float 1.3s ease-in-out infinite alternate;
}

@keyframes float
{
  
  100% {
    transform: translateY(10px);
    -webkit-transform: translateY(10px);
    -moz-transform: translateY(10px);
    -ms-transform: translateY(10px);
    -o-transform: translateY(10px);
  }
}



/* TAILWIND*/

/* ! tailwindcss v3.4.6 | MIT License | https://tailwindcss.com */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  
}
.visible{
  visibility: visible
}
.fixed{
  position: fixed
}
.absolute{
  position: absolute
}
.relative{
  position: relative
}
.inset-x-0{
  left: 0px;
  right: 0px
}
.bottom-0{
  bottom: 0px
}
.bottom-10{
  bottom: 2.5rem
}
.bottom-3{
  bottom: 0.75rem
}
.bottom-4{
  bottom: 1rem
}
.bottom-\\[10\\%\\]{
  bottom: 10%
}
.bottom-\\[10vw\\]{
  bottom: 10vw
}
.bottom-\\[1vw\\]{
  bottom: 1vw
}
.bottom-\\[20\\%\\]{
  bottom: 20%
}
.bottom-\\[50px\\]{
  bottom: 50px
}
.left-1\\/2{
  left: 50%
}
.left-10{
  left: 2.5rem
}
.left-2{
  left: 0.5rem
}
.left-5{
  left: 1.25rem
}
.left-\\[10\\%\\]{
  left: 10%
}
.left-\\[17vw\\]{
  left: 17vw
}
.left-\\[30vw\\]{
  left: 30vw
}
.left-\\[8vw\\]{
  left: 8vw
}
.right-0{
  right: 0px
}
.right-2{
  right: 0.5rem
}
.right-4{
  right: 1rem
}
.right-5{
  right: 1.25rem
}
.right-\\[10\\%\\]{
  right: 10%
}
.right-\\[11vw\\]{
  right: 11vw
}
.right-\\[14vw\\]{
  right: 14vw
}
.right-\\[1vw\\]{
  right: 1vw
}
.right-\\[28vw\\]{
  right: 28vw
}
.right-\\[40px\\]{
  right: 40px
}
.right-\\[8vw\\]{
  right: 8vw
}
.top-0{
  top: 0px
}
.top-1\\/2{
  top: 50%
}
.top-\\[10\\%\\]{
  top: 10%
}
.top-\\[15\\%\\]{
  top: 15%
}
.top-\\[15vw\\]{
  top: 15vw
}
.top-\\[22vw\\]{
  top: 22vw
}
.top-\\[23vh\\]{
  top: 23vh
}
.top-\\[250px\\]{
  top: 250px
}
.top-\\[300px\\]{
  top: 300px
}
.top-\\[350px\\]{
  top: 350px
}
.top-\\[35vh\\]{
  top: 35vh
}
.top-\\[45\\%\\]{
  top: 45%
}
.top-\\[45vh\\]{
  top: 45vh
}
.z-0{
  z-index: 0
}
.z-10{
  z-index: 10
}
.z-20{
  z-index: 20
}
.z-50{
  z-index: 50
}
.z-\\[100\\]{
  z-index: 100
}
.z-\\[10\\]{
  z-index: 10
}
.z-\\[1\\]{
  z-index: 1
}
.z-\\[200\\]{
  z-index: 200
}
.z-\\[2\\]{
  z-index: 2
}
.z-\\[7\\]{
  z-index: 7
}
.z-\\[8\\]{
  z-index: 8
}
.z-\\[999\\]{
  z-index: 999
}
.z-\\[99\\]{
  z-index: 99
}
.z-\\[9\\]{
  z-index: 9
}
.m-2{
  margin: 0.5rem
}
.m-4{
  margin: 1rem
}
.m-auto{
  margin: auto
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem
}
.mx-8{
  margin-left: 2rem;
  margin-right: 2rem
}
.mx-\\[100px\\]{
  margin-left: 100px;
  margin-right: 100px
}
.mx-\\[10px\\]{
  margin-left: 10px;
  margin-right: 10px
}
.mx-\\[10vw\\]{
  margin-left: 10vw;
  margin-right: 10vw
}
.mx-\\[12px\\]{
  margin-left: 12px;
  margin-right: 12px
}
.mx-\\[12vw\\]{
  margin-left: 12vw;
  margin-right: 12vw
}
.mx-\\[20vw\\]{
  margin-left: 20vw;
  margin-right: 20vw
}
.mx-\\[5vw\\]{
  margin-left: 5vw;
  margin-right: 5vw
}
.mx-\\[7vw\\]{
  margin-left: 7vw;
  margin-right: 7vw
}
.mx-\\[8vw\\]{
  margin-left: 8vw;
  margin-right: 8vw
}
.my-10{
  margin-top: 2.5rem;
  margin-bottom: 2.5rem
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem
}
.mb-1{
  margin-bottom: 0.25rem
}
.mb-10{
  margin-bottom: 2.5rem
}
.mb-14{
  margin-bottom: 3.5rem
}
.mb-16{
  margin-bottom: 4rem
}
.mb-2{
  margin-bottom: 0.5rem
}
.mb-4{
  margin-bottom: 1rem
}
.ml-10{
  margin-left: 2.5rem
}
.ml-2{
  margin-left: 0.5rem
}
.mr-10{
  margin-right: 2.5rem
}
.mr-20{
  margin-right: 5rem
}
.ms-auto{
  margin-inline-start: auto
}
.mt-0{
  margin-top: 0px
}
.mt-1{
  margin-top: 0.25rem
}
.mt-10{
  margin-top: 2.5rem
}
.mt-12{
  margin-top: 3rem
}
.mt-14{
  margin-top: 3.5rem
}
.mt-16{
  margin-top: 4rem
}
.mt-2{
  margin-top: 0.5rem
}
.mt-20{
  margin-top: 5rem
}
.mt-3{
  margin-top: 0.75rem
}
.mt-4{
  margin-top: 1rem
}
.mt-5{
  margin-top: 1.25rem
}
.mt-6{
  margin-top: 1.5rem
}
.mt-8{
  margin-top: 2rem
}
.mt-\\[100px\\]{
  margin-top: 100px
}
.mt-\\[10vh\\]{
  margin-top: 10vh
}
.mt-\\[90px\\]{
  margin-top: 90px
}
.flex{
  display: flex
}
.grid{
  display: grid
}
.hidden{
  display: none
}
.aspect-square{
  aspect-ratio: 1 / 1
}
.aspect-video{
  aspect-ratio: 16 / 9
}
.h-20{
  height: 5rem
}
.h-\\[100\\%\\]{
  height: 100%
}
.h-\\[100vh\\]{
  height: 100vh
}
.h-\\[10vw\\]{
  height: 10vw
}
.h-\\[120vh\\]{
  height: 120vh
}
.h-\\[12vw\\]{
  height: 12vw
}
.h-\\[130vh\\]{
  height: 130vh
}
.h-\\[13vw\\]{
  height: 13vw
}
.h-\\[14vw\\]{
  height: 14vw
}
.h-\\[15\\.6vw\\]{
  height: 15.6vw
}
.h-\\[150vw\\]{
  height: 150vw
}
.h-\\[15vh\\]{
  height: 15vh
}
.h-\\[15vw\\]{
  height: 15vw
}
.h-\\[180px\\]{
  height: 180px
}
.h-\\[180vh\\]{
  height: 180vh
}
.h-\\[20vw\\]{
  height: 20vw
}
.h-\\[23vw\\]{
  height: 23vw
}
.h-\\[24vw\\]{
  height: 24vw
}
.h-\\[25vh\\]{
  height: 25vh
}
.h-\\[2px\\]{
  height: 2px
}
.h-\\[300px\\]{
  height: 300px
}
.h-\\[30px\\]{
  height: 30px
}
.h-\\[30vh\\]{
  height: 30vh
}
.h-\\[30vw\\]{
  height: 30vw
}
.h-\\[35vw\\]{
  height: 35vw
}
.h-\\[390px\\]{
  height: 390px
}
.h-\\[40px\\]{
  height: 40px
}
.h-\\[40vw\\]{
  height: 40vw
}
.h-\\[5vw\\]{
  height: 5vw
}
.h-\\[60vh\\]{
  height: 60vh
}
.h-\\[60vw\\]{
  height: 60vw
}
.h-\\[6vw\\]{
  height: 6vw
}
.h-\\[70vh\\]{
  height: 70vh
}
.h-\\[70vw\\]{
  height: 70vw
}
.h-\\[72px\\]{
  height: 72px
}
.h-\\[7vw\\]{
  height: 7vw
}
.h-\\[80vh\\]{
  height: 80vh
}
.h-\\[80vw\\]{
  height: 80vw
}
.h-\\[8em\\]{
  height: 8em
}
.h-\\[92\\%\\]{
  height: 92%
}
.h-\\[95\\%\\]{
  height: 95%
}
.h-auto{
  height: auto
}
.h-full{
  height: 100%
}
.max-h-\\[80vw\\]{
  max-height: 80vw
}
.min-h-\\[100vh\\]{
  min-height: 100vh
}
.min-h-\\[120vh\\]{
  min-height: 120vh
}
.min-h-\\[130vh\\]{
  min-height: 130vh
}
.min-h-\\[150vh\\]{
  min-height: 150vh
}
.min-h-\\[2vw\\]{
  min-height: 2vw
}
.w-1\\/2{
  width: 50%
}
.w-1\\/3{
  width: 33.333333%
}
.w-10{
  width: 2.5rem
}
.w-2\\/3{
  width: 66.666667%
}
.w-6{
  width: 1.5rem
}
.w-\\[1\\.2vw\\]{
  width: 1.2vw
}
.w-\\[1\\.5vw\\]{
  width: 1.5vw
}
.w-\\[1\\.8vw\\]{
  width: 1.8vw
}
.w-\\[100\\%\\]{
  width: 100%
}
.w-\\[100vw\\]{
  width: 100vw
}
.w-\\[10vw\\]{
  width: 10vw
}
.w-\\[120vw\\]{
  width: 120vw
}
.w-\\[12vw\\]{
  width: 12vw
}
.w-\\[15\\.6vw\\]{
  width: 15.6vw
}
.w-\\[15vh\\]{
  width: 15vh
}
.w-\\[15vw\\]{
  width: 15vw
}
.w-\\[180px\\]{
  width: 180px
}
.w-\\[18vw\\]{
  width: 18vw
}
.w-\\[20\\%\\]{
  width: 20%
}
.w-\\[20vw\\]{
  width: 20vw
}
.w-\\[25\\%\\]{
  width: 25%
}
.w-\\[25\\.5vw\\]{
  width: 25.5vw
}
.w-\\[25vw\\]{
  width: 25vw
}
.w-\\[3\\.2vw\\]{
  width: 3.2vw
}
.w-\\[30\\%\\]{
  width: 30%
}
.w-\\[300px\\]{
  width: 300px
}
.w-\\[30px\\]{
  width: 30px
}
.w-\\[30vw\\]{
  width: 30vw
}
.w-\\[35vw\\]{
  width: 35vw
}
.w-\\[38\\.18vw\\]{
  width: 38.18vw
}
.w-\\[3vw\\]{
  width: 3vw
}
.w-\\[40\\%\\]{
  width: 40%
}
.w-\\[40px\\]{
  width: 40px
}
.w-\\[45vw\\]{
  width: 45vw
}
.w-\\[5\\.5vw\\]{
  width: 5.5vw
}
.w-\\[50\\%\\]{
  width: 50%
}
.w-\\[55\\%\\]{
  width: 55%
}
.w-\\[5vw\\]{
  width: 5vw
}
.w-\\[60\\%\\]{
  width: 60%
}
.w-\\[60vw\\]{
  width: 60vw
}
.w-\\[6vw\\]{
  width: 6vw
}
.w-\\[70\\%\\]{
  width: 70%
}
.w-\\[70vw\\]{
  width: 70vw
}
.w-\\[7vw\\]{
  width: 7vw
}
.w-\\[80\\%\\]{
  width: 80%
}
.w-\\[8em\\]{
  width: 8em
}
.w-\\[8vw\\]{
  width: 8vw
}
.w-\\[90\\%\\]{
  width: 90%
}
.w-\\[90vw\\]{
  width: 90vw
}
.w-\\[95vw\\]{
  width: 95vw
}
.w-\\[calc\\(100\\%-2rem\\)\\]{
  width: calc(100% - 2rem)
}
.w-full{
  width: 100%
}
.min-w-\\[100px\\]{
  min-width: 100px
}
.min-w-\\[120vw\\]{
  min-width: 120vw
}
.max-w-\\[100\\%\\]{
  max-width: 100%
}
.max-w-\\[100px\\]{
  max-width: 100px
}
.max-w-\\[150px\\]{
  max-width: 150px
}
.max-w-\\[160px\\]{
  max-width: 160px
}
.flex-1{
  flex: 1 1
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.cursor-pointer{
  cursor: pointer
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr))
}
.flex-col{
  flex-direction: column
}
.flex-wrap{
  flex-wrap: wrap
}
.content-center{
  align-content: center
}
.content-start{
  align-content: flex-start
}
.items-start{
  align-items: flex-start
}
.items-end{
  align-items: flex-end
}
.items-center{
  align-items: center
}
.justify-start{
  justify-content: flex-start
}
.justify-end{
  justify-content: flex-end
}
.justify-center{
  justify-content: center
}
.justify-between{
  justify-content: space-between
}
.justify-evenly{
  justify-content: space-evenly
}
.gap-10{
  gap: 2.5rem
}
.gap-2{
  gap: 0.5rem
}
.gap-20{
  gap: 5rem
}
.gap-3{
  gap: 0.75rem
}
.gap-4{
  gap: 1rem
}
.gap-x-14{
  column-gap: 3.5rem
}
.gap-y-16{
  row-gap: 4rem
}
.overflow-hidden{
  overflow: hidden
}
.overflow-x-hidden{
  overflow-x: hidden
}
.overflow-y-hidden{
  overflow-y: hidden
}
.break-words{
  overflow-wrap: break-word
}
.break-all{
  word-break: break-all
}
.rounded-\\[50\\%\\]{
  border-radius: 50%
}
.rounded-full{
  border-radius: 9999px
}
.rounded-md{
  border-radius: 0.375rem
}
.border-\\[1px\\]{
  border-width: 1px
}
.border-\\[2px\\]{
  border-width: 2px
}
.border-\\[4px\\]{
  border-width: 4px
}
.border-b{
  border-bottom-width: 1px
}
.border-b-2{
  border-bottom-width: 2px
}
.border-b-\\[1px\\]{
  border-bottom-width: 1px
}
.border-\\[\\#666666\\]{
  --tw-border-opacity: 1;
  border-color: rgb(102 102 102 / var(--tw-border-opacity))
}
.border-\\[\\#D9D9D9\\]{
  --tw-border-opacity: 1;
  border-color: rgb(217 217 217 / var(--tw-border-opacity))
}
.border-\\[white\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity))
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity))
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity))
}
.bg-\\[\\#0008\\]{
  background-color: #0008
}
.bg-\\[black\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity))
}
.bg-\\[rgb\\(0\\2c 0\\2c 0\\)\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity))
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.14\\)\\]{
  background-color: rgba(0,0,0,0.14)
}
.bg-\\[white\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity))
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5)
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7)
}
.bg-current{
  background-color: currentColor
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity))
}
.bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity))
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.bg-cover{
  background-size: cover
}
.bg-center{
  background-position: center
}
.bg-no-repeat{
  background-repeat: no-repeat
}
.bg-repeat-x{
  background-repeat: repeat-x
}
.fill-black{
  fill: #000
}
.object-contain{
  object-fit: contain
}
.object-cover{
  object-fit: cover
}
.object-fill{
  object-fit: fill
}
.object-center{
  object-position: center
}
.p-10{
  padding: 2.5rem
}
.p-4{
  padding: 1rem
}
.p-\\[1vw\\]{
  padding: 1vw
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem
}
.px-14{
  padding-left: 3.5rem;
  padding-right: 3.5rem
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem
}
.px-20{
  padding-left: 5rem;
  padding-right: 5rem
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem
}
.px-\\[100px\\]{
  padding-left: 100px;
  padding-right: 100px
}
.px-\\[10vw\\]{
  padding-left: 10vw;
  padding-right: 10vw
}
.px-\\[15vw\\]{
  padding-left: 15vw;
  padding-right: 15vw
}
.px-\\[5vw\\]{
  padding-left: 5vw;
  padding-right: 5vw
}
.px-\\[8vw\\]{
  padding-left: 8vw;
  padding-right: 8vw
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem
}
.py-\\[10vh\\]{
  padding-top: 10vh;
  padding-bottom: 10vh
}
.py-\\[4vw\\]{
  padding-top: 4vw;
  padding-bottom: 4vw
}
.pb-10{
  padding-bottom: 2.5rem
}
.pb-12{
  padding-bottom: 3rem
}
.pb-2{
  padding-bottom: 0.5rem
}
.pb-20{
  padding-bottom: 5rem
}
.pb-3{
  padding-bottom: 0.75rem
}
.pb-4{
  padding-bottom: 1rem
}
.pb-6{
  padding-bottom: 1.5rem
}
.pb-8{
  padding-bottom: 2rem
}
.pb-\\[200px\\]{
  padding-bottom: 200px
}
.pb-\\[4vw\\]{
  padding-bottom: 4vw
}
.pl-3{
  padding-left: 0.75rem
}
.pl-4{
  padding-left: 1rem
}
.pl-\\[10\\%\\]{
  padding-left: 10%
}
.pl-\\[11vw\\]{
  padding-left: 11vw
}
.pr-\\[80px\\]{
  padding-right: 80px
}
.pr-\\[8vw\\]{
  padding-right: 8vw
}
.pt-10{
  padding-top: 2.5rem
}
.pt-16{
  padding-top: 4rem
}
.pt-20{
  padding-top: 5rem
}
.pt-4{
  padding-top: 1rem
}
.pt-6{
  padding-top: 1.5rem
}
.pt-8{
  padding-top: 2rem
}
.pt-\\[10vh\\]{
  padding-top: 10vh
}
.pt-\\[140px\\]{
  padding-top: 140px
}
.pt-\\[16vw\\]{
  padding-top: 16vw
}
.pt-\\[200px\\]{
  padding-top: 200px
}
.pt-\\[2vh\\]{
  padding-top: 2vh
}
.pt-\\[40px\\]{
  padding-top: 40px
}
.pt-\\[4vw\\]{
  padding-top: 4vw
}
.pt-\\[5vh\\]{
  padding-top: 5vh
}
.text-left{
  text-align: left
}
.text-center{
  text-align: center
}
.text-justify{
  text-align: justify
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem
}
.text-5xl{
  font-size: 3rem;
  line-height: 1
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1
}
.text-\\[0\\.8vw\\]{
  font-size: 0.8vw
}
.text-\\[1\\.5vw\\]{
  font-size: 1.5vw
}
.text-\\[10vw\\]{
  font-size: 10vw
}
.text-\\[12px\\]{
  font-size: 12px
}
.text-\\[13px\\]{
  font-size: 13px
}
.text-\\[14px\\]{
  font-size: 14px
}
.text-\\[15px\\]{
  font-size: 15px
}
.text-\\[16px\\]{
  font-size: 16px
}
.text-\\[18px\\]{
  font-size: 18px
}
.text-\\[1vw\\]{
  font-size: 1vw
}
.text-\\[2\\.5vw\\]{
  font-size: 2.5vw
}
.text-\\[20px\\]{
  font-size: 20px
}
.text-\\[24px\\]{
  font-size: 24px
}
.text-\\[25px\\]{
  font-size: 25px
}
.text-\\[2vw\\]{
  font-size: 2vw
}
.text-\\[3\\.5vw\\]{
  font-size: 3.5vw
}
.text-\\[32px\\]{
  font-size: 32px
}
.text-\\[34px\\]{
  font-size: 34px
}
.text-\\[3vw\\]{
  font-size: 3vw
}
.text-\\[48px\\]{
  font-size: 48px
}
.text-\\[4vw\\]{
  font-size: 4vw
}
.text-\\[50px\\]{
  font-size: 50px
}
.text-\\[5vw\\]{
  font-size: 5vw
}
.text-\\[64px\\]{
  font-size: 64px
}
.text-\\[72px\\]{
  font-size: 72px
}
.text-\\[90\\%\\]{
  font-size: 90%
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem
}
.font-bold{
  font-weight: 700
}
.font-semibold{
  font-weight: 600
}
.text-\\[\\#666666\\]{
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity))
}
.text-\\[\\#9CA3AF\\]{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity))
}
.text-\\[1w\\]{
  color: 1w
}
.text-\\[grey\\]{
  --tw-text-opacity: 1;
  color: rgb(128 128 128 / var(--tw-text-opacity))
}
.text-\\[white\\]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity))
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity))
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.no-underline{
  text-decoration-line: none
}
.opacity-\\[0\\.5\\]{
  opacity: 0.5
}
.opacity-\\[0\\]{
  opacity: 0
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.outline{
  outline-style: solid
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}
.duration-100{
  transition-duration: 100ms
}
.duration-500{
  transition-duration: 500ms
}
.duration-\\[1000ms\\]{
  transition-duration: 1000ms
}
.duration-\\[500ms\\]{
  transition-duration: 500ms
}
.hover\\:scale-\\[2\\]:hover{
  --tw-scale-x: 2;
  --tw-scale-y: 2;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.hover\\:cursor-pointer:hover{
  cursor: pointer
}
.hover\\:bg-\\[\\#0009\\]:hover{
  background-color: #0009
}
.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity))
}
.hover\\:opacity-\\[100\\]:hover{
  opacity: 100
}
.group:hover .group-hover\\:fill-white{
  fill: #fff
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;EACE,gCAAgC;AAClC;;AAEA,UAAU;;AAEV;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;;;GAGG,uBAAuB;GACvB,sCAAsC;GACtC,oBAAoB;AACvB;;AAEA,wBAAwB;;AAExB;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;;;GAGG,uBAAuB;GACvB,sCAAsC;GACtC,oBAAoB;AACvB;;;;;AAKA,8BAA8B;;AAE9B;EACE,YAAY;EACZ,aAAa;EACb,iCAAiC;;AAEnC;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,QAAQ;;EAEV;;EAEA;IACE,aAAa;IACb,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,cAAc;IACd,QAAQ;EACV;;;EAGA;IACE,aAAa;IACb,cAAc;IACd,WAAW;EACb;EACA;IACE,aAAa;IACb,cAAc;IACd,WAAW;IACX,aAAa;EACf;AACF;;;;AAIA,uBAAuB;AACvB;EACE,oDAAoD;AACtD;;AAEA;;;EAGE;IACE,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;EAChC;AACF;;;;AAIA,YAAY;;AAEZ,iEAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAhLnB;EAAA,eAiLA;EAjLA,eAiLA;EAjLA;AAiLA;AAjLA;EAAA;AAiLA;AAjLA;EAAA;AAiLA;AAjLA;EAAA,oBAiLA;EAjLA;AAiLA;AAjLA;EAAA;AAiLA;AAjLA;EAAA;AAiLA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');\n\n* {\n  font-family: 'Montserrat', sans-serif\n}\n\n.nav-link {\n  color: white !important;\n}\n\n\na {\n  text-decoration: none !important;\n}\n\n/* HOVER */\n\n.custom-hover {\n  position: relative;\n  color: white;\n  overflow: hidden;\n  /* border: solid 1px; */\n  outline: none !important;\n  z-index: 99;\n  background: white;\n}\n\n.custom-hover:hover {\n  color:  black;\n}\n\n.custom-hover::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: black;\n  z-index: -1;\n  border-radius: 10%;\n  transform-origin: left;\n  transition: transform 500ms ease-in-out;\n  transform: scaleX(1);\n}\n\n.custom-hover:hover::before,\n.custom-hover:focus::before\n {\n   transform-origin: right;\n   transition: transform 0.5s ease-in-out;\n   transform: scaleX(0);\n}\n\n/* REVERSE COLOR HOVER */\n\n.reverse-custom-hover {\n  position: relative;\n  color: black;\n  overflow: hidden;\n  border: solid 1px;\n  outline: none !important;\n  z-index: 99;\n  background: black;\n}\n\n.reverse-custom-hover:hover {\n  color: white;\n}\n\n.reverse-custom-hover::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: white;\n  z-index: -1;\n  border-radius: 10%;\n  transform-origin: left;\n  transition: transform 500ms ease-in-out;\n  transform: scaleX(1);\n}\n\n.reverse-custom-hover:hover::before,\n.reverse-custom-hover:focus::before\n {\n   transform-origin: right;\n   transition: transform 0.5s ease-in-out;\n   transform: scaleX(0);\n}\n\n\n\n\n/* ART TYPE OPENING ANIMATION*/\n\n.custom-animation {\n  width: 100px;\n  height: 150px;\n  animation: animate 5s ease-in-out;\n  \n}\n\n@keyframes animate {\n  0% {\n    height: 150px;\n    width: 100px;\n    top: 50%;\n  }\n\n  20% {\n    height: 300px;\n    width: 300px;\n    top: 50%;\n  }\n\n  30% {\n    height: 300px;\n    width: 300px;\n    top: 50%;\n\n  }\n\n  50% {\n    width: 1000px;\n    height: 1000px;\n    top: 50%;\n  }\n\n  60% {\n    width: 1000px;\n    height: 1000px;\n    top: 50%;\n  }\n  \n\n  85% {\n    width: 1000px;\n    height: 1000px;\n    top: -200vh;\n  }\n  100% {\n    width: 1000px;\n    height: 1000px;\n    top: -200vh;\n    display: none;\n  }\n}\n\n\n\n/* FLOATING ANIMATION */\n.floating {\n  animation: float 1.3s ease-in-out infinite alternate;\n}\n\n@keyframes float\n{\n  \n  100% {\n    transform: translateY(10px);\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n  }\n}\n\n\n\n/* TAILWIND*/\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
